import React, { useMemo } from "react";
import DataTagSensitivityFilter from "../Data Tag FIlters/DataTagSensitivityFilter";
import DataTagCategoryFilters from "../Data Tag FIlters/DataTagCategoryFilters";
import TypeFilterDropdown from "./TypeFilterDropdown";
import { FileExtensionFilter } from "./FileExtensionFilter";
import { REGULATED_COLOR_PALETTE } from "../DataTagConstants";

const QuickFilters = ({
  showCategory = false,
  categoryValue = [],
  onCategoryChange,
  sensitivityValue = [],
  onSensitivityChange,
  regulatedValue = [],
  onRegulatedChange,
  filters,
  typeFilterList = {},
  typeFilter = [],
  onTypeFilterValue,
  extensionFilter = [],
  onExtensionFilter,
  loc,
}) => {
  const extensionFilterList = useMemo(
    () => FileExtensionFilter(typeFilterList, typeFilter),
    [typeFilterList, typeFilter]
  );

  const handleTypeChange = (types) => {
    onTypeFilterValue(types);

    onExtensionFilter((prev = []) =>
      prev.filter((ext) =>
        types.some((type) => typeFilterList[type]?.includes(ext))
      )
    );
  };

  const classificationColors = useMemo(() => {
    const sortedFilters = [...(filters || [])].sort((a, b) =>
      a.localeCompare(b),
    );

    return sortedFilters.reduce((acc, classification, index) => {
      acc[classification] = REGULATED_COLOR_PALETTE[index % REGULATED_COLOR_PALETTE.length];

      return acc;
    }, {});
  }, [filters]);

  return (
    <div className="DataTagFilterContainer">
      {loc !== "data-estate-drives" && (
        <>
          <div className="quick-filter-bar">
            <span className="quick-filter-title">File Type:</span>
            <TypeFilterDropdown
              typeFilterList={typeFilterList}
              value={typeFilter}
              onChange={handleTypeChange}
              variant="type"
              placeholder="select type"
            />
          </div>

          <div className="quick-filter-bar">
            <span className="quick-filter-title">Extension:</span>
            <TypeFilterDropdown
              typeFilterList={extensionFilterList}
              value={extensionFilter}
              onChange={onExtensionFilter}
              variant="extension"
              disabled={typeFilter.length === 0}
              placeholder="select extension"
            />
          </div>
        </>
      )}

      {filters && filters.length > 0 && loc !== "data-estate-drives" && (
        <div className="quick-filter-bar">
          <span className="quick-filter-title">Regulated:</span>
          <div className="ss-filters">
            {filters.map((type) => {
              const active = regulatedValue.includes(type);
              return (
                <div
                  key={type}
                  className={`ss-filter ${active ? "active" : ""}`}
                  style={{ "--filter-color": classificationColors[type] }}
                  onClick={() => onRegulatedChange(type)}
                >
                  {type}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {showCategory && (
        <div className="quick-filter-bar">
          <span className="quick-filter-title">Category:</span>
          <DataTagCategoryFilters
            value={categoryValue}
            onChange={onCategoryChange}
            loc={loc}
          />
        </div>
      )}

      <div className="quick-filter-bar">
        <span className="quick-filter-title">Sensitivity:</span>
        <DataTagSensitivityFilter
          value={sensitivityValue}
          onChange={onSensitivityChange}
          loc={loc}
        />
      </div>
    </div>
  );
};

export default QuickFilters;
